/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GolabControllerAutomaticallyTranslateAllGolabAppsAndLabs$Params {
}

export function golabControllerAutomaticallyTranslateAllGolabAppsAndLabs(http: HttpClient, rootUrl: string, params?: GolabControllerAutomaticallyTranslateAllGolabAppsAndLabs$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, golabControllerAutomaticallyTranslateAllGolabAppsAndLabs.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

golabControllerAutomaticallyTranslateAllGolabAppsAndLabs.PATH = '/golab/automatically-translate-all-apps-and-labs';
